import React, { useState, useEffect, useRef } from 'react';
import { loaderStateTrue, loaderStateFalse, userSearchData, priceDistributionResponseData, priceDistributionRequestData, trendingDestination, tourSearchData, groupTourPackageSearchData } from '../../../../Actions/AllAction';
import { setUserCredentials } from '../../../../GlobalModules/Login/Actions/LoginAction';
import { connect } from 'react-redux';
import { withRouter, useHistory, useParams } from 'react-router-dom';
import '../../../../Utility/Public/css/common.scss';
import '../../Payment/Assets/css/paymentdoc.scss';
import '../../Payment/Assets/css/paymentresponsivedoc.scss';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import BreadcrumbMenu from '../../../../Utility/Components/BreadcrumbMenu';
import LazyImage from '../../../../Utility/Components/LazyImageComponent';
import ErrorBoundary from 'antd/es/alert/ErrorBoundary';
import moment from 'moment';
import Utility from '../../../../Utility/Utility';
import { getGSTdetails } from '../Controller/HomeController';
import TourBooking from '../Components/TourBooking';
import ModalGlobal from '../../../../Utility/Components/ModalGlobal';
import ConfirmationAlert from '../../../../Utility/Components/ConfirmationAlert';
import { customerWorkStatus } from '../../../../Utility/Controller/UtilityController';
import { redirectToAuth } from '../../../../Utility/helpers/authRedirect';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import GroupPackageSearchPanel from '../Components/GroupPackageSearchPanel'
import { getGroupTourApi } from '../../../../GlobalModules/Login/Controller/LoginController';

function TourDetails(props) {
    const params = useParams();
    const slug = params.slug || props.match?.params?.slug;
    console.log("[DEBUG] TourDetails mounted/renamed. params.slug:", params.slug);
    console.log("[DEBUG] TourDetails slug:", slug);
    console.log("[DEBUG] TourDetails props.match?.params?.slug:", props.match?.params?.slug);
    const [showFull, setShowFull] = useState(false);
    const history = useHistory();
    // Lightbox states
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [currentSlide, setCurrentSlide] = useState(0);
    const [lightboxImages, setLightboxImages] = useState([]);
    const [isIncludeTravelFare, setIsIncludeTravelFare] = useState(false);
    const [groupTourState, setGroupTourState] = useState([]);

    const toggleShowFull = (type) => {
        if (type === 'mob') {
            setShowFull(!showFull);
        }
    };
    const formatTime = (inputTime) => {
        let time = new Date('1970-01-01T' + inputTime);
        let hours = time.getHours();
        let minutes = time.getMinutes();
        hours = hours < 10 ? '0' + hours : hours;
        minutes = minutes < 10 ? '0' + minutes : minutes;
        return hours + ':' + minutes;
    }

    const [nav1, setNav1] = useState(null);
    const [nav2, setNav2] = useState(null);
    const slider1 = useRef(null);
    const slider2 = useRef(null);
const [overlay, setOverlay] = useState(true)
    useEffect(() => {
        setNav1(slider1.current);
        setNav2(slider2.current);
    }, []);

    const rawImages = (() => {
        const data = props.tourSearchDataFromReducer || {};
        if (Array.isArray(data.gallery_images) && data.gallery_images.length > 0) {
            return data.gallery_images;
        }
        if (Array.isArray(data.Media) && data.Media.length > 0 && data.Media[0]?.file_url) {
            try {
                const mediaFiles = JSON.parse(data.Media[0].file_url);
                if (Array.isArray(mediaFiles) && mediaFiles.length > 0) {
                    return mediaFiles.map((m) => m.file_url).filter(Boolean);
                }
            } catch (e) {
                return [data.Media[0].file_url];
            }
        }
        return [];
    })();
    const images = rawImages.filter(
        (item, index, self) =>
            index ===
            self.findIndex(
                (t) =>
                    t === item
            )
    );
    const [isGuestFlag, setIsGuestFlag] = useState(false);
    const [gstPercentage, setGSTPercentage] = useState(0);
    const [sacCodeId, setSacCodeId] = useState(0);
    const [defaultBranch, setDefaultBranch] = useState({});
    const [paymentDetailsModalFlag, setPaymentDetailsModalFlag] = useState(false);
    const [fareAmountPopupFlag, setFareAmountPopupFlag] = useState(false);
    const [callFromConfirmation, setCallFromConfirmation] = useState("");

    const openLightbox = (tour = {}, images = []) => {
        if (images.length > 0) {
            setLightboxImages(images);
            setCurrentSlide(0);
            setLightboxOpen(true);
        }
    };

    const roomTypeUi = () => {
        const selectedTour = props.tourSearchDataFromReducer;
        if (!selectedTour) return null;
        // console.log("selectedTour-----", selectedTour)

        const renderList = (label, list) => {
            if (!list || (Array.isArray(list) && list.length === 0)) return null;
            const textArr = Array.isArray(list)
                ? list.map(entry => {
                    if (typeof entry === 'string') return entry;
                    if (entry && typeof entry === 'object') {
                        return entry.inclusion_text || entry.exclusion_text || '';
                    }
                    return '';
                }).filter(text => text !== '')
                : [list];
            if (textArr.length === 0) return null;
            return (
                <li className='tourDetails'>
                    {label} {textArr.join(', ')}
                </li>
            );
        };
        const highlightItems = props.tourSearchDataFromReducer.highlights ? props.tourSearchDataFromReducer.highlights.split(',').map(item => item.trim()) : [];
        const fareAmount = Number(props.tourSearchDataFromReducer?.fare_amount);
        return (
            <div className="tour-room-section">
                <div className="room-details-section">
                    <div className="mediaBoxes">
                        <div className="mediaBoxLeftSide">
                            <div className="tourDetailsBoxDesk">
                                {selectedTour.hasOwnProperty('tour_code') && selectedTour.tour_code != "" && selectedTour.tour_code != null && (
                                    <h6><strong>Tour Code: {selectedTour.tour_code}</strong></h6>
                                )}
                                {selectedTour.hasOwnProperty('tour_description') && selectedTour.tour_description != "" && selectedTour.tour_description != null && (
                                    <p><span>{selectedTour.tour_description}</span></p>
                                )}
                                {selectedTour.hasOwnProperty('tour_guide_info') && selectedTour.tour_guide_info != "" && selectedTour.tour_guide_info != null && (
                                    <ul className='tour_guide_info'><li><strong>Guide information:</strong> {selectedTour.tour_guide_info}</li></ul>
                                )}
                                {highlightItems.length > 0 && (
                                    <div className='roomtypeDetailsBox'>
                                        <div className='highlights-list'>
                                            {highlightItems.map((item, index) => (
                                                <p key={index} className='highlights'>
                                                    <img
                                                        className="highlights-icon"
                                                        src={require('../../../../Utility/Public/images/highlights_tick.png')}
                                                        alt="tick"
                                                    />{" "}
                                                    {item}
                                                </p>
                                            ))}
                                        </div>
                                    </div>
                                )}
                                {selectedTour.hasOwnProperty('stopovers') && selectedTour.stopovers != "" && selectedTour.stopovers != null && (
                                    <ul className='tour_guide_info'><li><strong>Stopover(s): </strong> {selectedTour.stopovers}</li></ul>
                                )}
                                <div className='roomtypeDetailsBox inclusionsExclusions'>
                                    {props.tourSearchDataFromReducer.inclusions != "" && props.tourSearchDataFromReducer.inclusions != null &&
                                        <ul className='inclusions-inner'>
                                            {renderList(<strong>Inclusions: </strong>, props.tourSearchDataFromReducer.inclusions)}
                                        </ul>
                                    }
                                    {props.tourSearchDataFromReducer.exclusions != "" && props.tourSearchDataFromReducer.exclusions != null &&
                                        <ul className='inclusions-inner'>
                                            {renderList(<strong>Exclusions: </strong>, props.tourSearchDataFromReducer.exclusions)}
                                        </ul>
                                    }
                                </div>
                                <div className='roomtypeDetailsBox inclusionsExclusions'>
                                    {props.tourSearchDataFromReducer.minimum_guest_count != "" && props.tourSearchDataFromReducer.minimum_guest_count != null &&
                                        <ul className='inclusions-inner'>
                                            <li><strong>Minimum guest count: </strong> {props.tourSearchDataFromReducer.minimum_guest_count}</li>
                                        </ul>
                                    }
                                    {props.tourSearchDataFromReducer.maximum_guest_count != "" && props.tourSearchDataFromReducer.maximum_guest_count != null &&
                                        <ul className='inclusions-inner'>
                                            <li><strong>Maximum guest count: </strong>{props.tourSearchDataFromReducer.maximum_guest_count}</li>
                                        </ul>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-sm-12'>
                            <div className="roomtypeDetailsBox dayWiseitenary">
                                {props.tourSearchDataFromReducer?.itinerary_json && (
                                    <div className="itinerarySection">
                                        {(Array.isArray(props.tourSearchDataFromReducer.itinerary_json)
                                            ? props.tourSearchDataFromReducer.itinerary_json
                                            : JSON.parse(props.tourSearchDataFromReducer.itinerary_json)
                                        ).map((dayItem, index) => (
                                            <div key={index} className="itineraryDayBox">
                                                <h5>Day {dayItem.day_number || dayItem.day}</h5>
                                                <div className='description-box'>
                                                    {(dayItem?.title || dayItem?.description) && (
                                                        <p className='description'>
                                                            {dayItem.title ? <strong>{dayItem.title} </strong> : ''}
                                                            {dayItem.title && dayItem.description ? ': ' : ''}
                                                            {dayItem.description ? dayItem.description : ''}
                                                        </p>
                                                    )}
                                                </div>
                                                <div className='itineraryBX'>
                                                    {dayItem.items && dayItem.items.length > 0 && (
                                                        <>
                                                            {dayItem.items.map((item, idx) => (
                                                                <div key={idx}>
                                                                    <p>
                                                                        <strong>{item.type ? `${item.type}: ` : ''}</strong>
                                                                        {item.title || ''}
                                                                        {item.description ? `: ${item.description}` : ''}
                                                                        {item.type === 'Transfer' && item.selectedCar && item.selectedCar.label && (
                                                                            <span> ({item.selectedCar.label})</span>
                                                                        )}
                                                                    </p>
                                                                    {item.images && item.images.length > 0 && (
                                                                        <div className='itineraryItemImages'>
                                                                            {item.images.map((image, imgIdx) =>
                                                                                image.file_url ? (
                                                                                    <img
                                                                                        key={imgIdx}
                                                                                        src={image.file_url}
                                                                                        alt={image.file_name || 'itinerary image'}
                                                                                        className='itineraryImage'
                                                                                        style={{ maxWidth: '120px', marginRight: '8px', marginBottom: '8px' }}
                                                                                    />
                                                                                ) : null
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            ))}
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                                <div className="roomtypeDetailsBox todayprice">
                                    <h6>Price details</h6>
                                    <div className="roomtypeDetailsBox inclusionsExclusions">
                                        <ul className="inclusions-inner price-details">
                                            <li className="tourDetails"><strong>{Utility.getCurrencySymbol(currency)} {selectedTour.price_for_adult} <sub>/ per Adult</sub></strong></li>
                                        </ul>
                                        <ul className="inclusions-inner price-details child-age-message">
                                            <li className="tourDetails"><strong> {Utility.getCurrencySymbol(currency)} {selectedTour.price_for_children}
                                                <sub>
                                                    / per Child <br />
                                                    {selectedTour.hasOwnProperty('minimum_age_child_price_applied') &&
                                                        selectedTour.minimum_age_child_price_applied != "" &&
                                                        selectedTour.minimum_age_child_price_applied != null && (
                                                            <span className='rules'>
                                                                {`(Child price applies for age ≥ ${selectedTour.minimum_age_child_price_applied} years)`}
                                                            </span>
                                                        )}
                                                </sub>
                                            </strong></li>
                                        </ul>
                                    </div>
                                </div>
                                {props.tourSearchDataFromReducer.hasOwnProperty('fare_amount') && fareAmount > 0 ?
                                    <div className="tourDetailsBoxDesk travel-allenes-box">
                                        {selectedTour.hasOwnProperty('fare_amount') && selectedTour.fare_amount != "" && selectedTour.fare_amount != null && (
                                            <ul className='tour_guide_info'><li><strong>Travel Fare: </strong>{Utility.getCurrencySymbol(currency)} {selectedTour.fare_amount}/person</li></ul>
                                        )}
                                    </div>
                                    : null}
                            </div>
                        </div>
                    </div>
                    {/* <div className="mediaBoxes mediaBoxesDoc">
                        {
                            props.tourSearchDataFromReducer.hasOwnProperty('content') && props.tourSearchDataFromReducer.content && props.tourSearchDataFromReducer.content.length > 0 && (
                                <div dangerouslySetInnerHTML={{ __html: props.tourSearchDataFromReducer.content }} />
                            )
                        }
                    </div> */}
                </div>
            </div>
        );
    };

    useEffect(() => {
        getGSTdetailsFN();
    }, [])

    useEffect(() => {
        if (typeof props.tourSearchDataFromReducer === 'object' && Object.keys(props.tourSearchDataFromReducer).length > 0 && props.tourSearchDataFromReducer.hasOwnProperty('branch_details') && props.tourSearchDataFromReducer.branch_details) {
            setDefaultBranch(props.tourSearchDataFromReducer?.branch_details);
        }
    }, [props.tourSearchDataFromReducer]);

    useEffect(() => {
        // console.log("defaultBranch", defaultBranch);
    }, [defaultBranch]);

    useEffect(() => {
        // Check both Redux state and localStorage token to avoid redirect loops
        const hasToken = localStorage.getItem('token') || localStorage.getItem('accessToken');
        if (!props.isLoggedIn && !hasToken) {
            const currentPath = props.location.pathname;
            const searchParams = new URLSearchParams(props.location.search);
            const language = localStorage.getItem('i18nextLng') || 'en';
            // Use redirectToAuth to preserve URL and parameters
            // redirectToAuth(props.history, currentPath, searchParams, 'login', language);
        } else {
            sessionStorage.setItem('previousUrl', `/${localStorage.getItem('i18nextLng')}/tour-details`)
        }
    }, [props.isLoggedIn, props.location, props.history]);

    useEffect(() => {
        if (props.isLoggedIn && props.selected_branch?.branch_id !== undefined) {
            let dataset = {
                [props.selected_branch?.branch_id]:
                {
                    type: "visited"
                }
            }
            customerWorkStatus(dataset);
        }
    }, [props.isLoggedIn])


    const getGSTdetailsFN = async () => {
        getGSTdetails().then((response) => {
            if (response.success && response.total > 0) {
                const match = response.data.find(item => item.sac_code === "998555");
                // sac_code_id
                const sac_code_id = match ? match.id : 0;
                setSacCodeId(sac_code_id);
                const gstRate = match ? match.gst_rate : 0;
                setGSTPercentage(gstRate);
            }
        }).catch((error) => {
            console.log(error);
        })
    }


    // checkout as  guest onclick fn 
    const openGuestCheckOutModalFn = Utility.debounceButton(async () => {
        const fareAmount = Number(props.tourSearchDataFromReducer?.fare_amount);
        let vaildData = true;
        if (vaildData) {
            if (fareAmount > 0 && !isIncludeTravelFare) {
                setFareAmountPopupFlag(true)
                setCallFromConfirmation("guest")
            } else {
                setIsGuestFlag(true)
                await hotelRoomBookedDataSave();
            }
        }
    }, 300);

    //proceed to booking debounce onclick fn 
    const openProceedPriceDistributionPage = Utility.debounceButton(async () => {
        const { userSearchDataFromReducer, selected_branch, userCredentials } = props;
        const fareAmount = Number(props.tourSearchDataFromReducer?.fare_amount);
        setIsGuestFlag(false)
        let vaildData = true;
        if (vaildData) {
            if (fareAmount > 0 && !isIncludeTravelFare) {
                if (Object.keys(userCredentials).length > 0) {
                    setFareAmountPopupFlag(true)
                    setCallFromConfirmation("book")
                } else {
                    const currentPath = props.location.pathname;
                    const searchParams = new URLSearchParams(props.location.search);
                    const language = localStorage.getItem('i18nextLng') || 'en';
                    // Use redirectToAuth to preserve URL and parameters
                    // redirectToAuth(props.history, currentPath, searchParams, 'login', language);
                    // props.history.push(`/${localStorage.getItem('i18nextLng')}/login/tour-details`);
                }
            } else {
                if (Object.keys(userCredentials).length > 0) {
                    await hotelRoomBookedDataSave();
                } else {
                    const currentPath = props.location.pathname;
                    const searchParams = new URLSearchParams(props.location.search);
                    const language = localStorage.getItem('i18nextLng') || 'en';
                    // Use redirectToAuth to preserve URL and parameters
                    // redirectToAuth(props.history, currentPath, searchParams, 'login', language);
                    // props.history.push(`/${localStorage.getItem('i18nextLng')}/login/tour-details`);
                }
            }
        }
    }, 300)

    //booking price distribution post api
    async function hotelRoomBookedDataSave() {
        const { loaderStateTrue, loaderStateFalse } = props;
        // console.log("------///props.tourSearchDataFromReducer///-------",)
        // let vaildData = validationRoomBookFromData();
        // if (vaildData) {
        //     let dataset = formatingHotelBookRoomData();
        //     setHotelRoomBookDataSet(dataset);
        //     props.priceDistributionRequestData(dataset);

        //     dataset = { 'full_journey_details': dataset, }
        //     // return false
        //     loaderStateTrue();
        //     paymentPriceDistribution(dataset).then((response) => {
        //         loaderStateFalse();
        //         if (response[0].success) {
        //             setPaymentDetailsModalFlag(true)
        //             let updatedData = {
        //                 ...response[0].data[0],
        //                 is_igst_enable: false,
        //             };
        //             setPaymentDetailsData(updatedData);
        //             props.priceDistributionResponseData(updatedData);
        //         } else {
        //             Utility.toastNotifications("Data Not Found", "Warning", "warning");
        //         }
        //     }).catch((error) => {
        //         console.error("************error*************", error)
        //         if (error) {
        //         }
        //         loaderStateFalse();
        //         if (error.message == "Network Error") {

        //         }
        //     });
        // }
        props.priceDistributionResponseData(props.tourSearchDataFromReducer);
        setPaymentDetailsModalFlag(true)
    }

    const closeQuotationCreateModalFn = () => {
        setPaymentDetailsModalFlag(false);
        setIsIncludeTravelFare(false)
    }

    const closePaymentDetailsModalFn = () => {
        setPaymentDetailsModalFlag(false);
        setIsIncludeTravelFare(false)
    }

    const handleChangeIncludeFareFn = (e, type) => {
        if (type == "include_transportation") {
            if (e.target.checked) {
                setIsIncludeTravelFare(true)
            } else {
                setIsIncludeTravelFare(false)
            }
        }
    };

    const closFareAmountPopup = () => {
        setFareAmountPopupFlag(false)
        setCallFromConfirmation("")
        setIsIncludeTravelFare(false)
    }

    const fareAmountConfirmButton = Utility.debounceButton(async () => {
        const { userSearchDataFromReducer, selected_branch, userCredentials } = props;
        if (callFromConfirmation == "guest") {
            let vaildData = true;
            if (vaildData) {
                setFareAmountPopupFlag(false)
                setIsGuestFlag(true)
                await hotelRoomBookedDataSave();
                setIsIncludeTravelFare(true)
                setCallFromConfirmation("")
            }
        } else if (callFromConfirmation == "book") {
            setCallFromConfirmation("")
            if (Object.keys(userCredentials).length > 0) {
                await hotelRoomBookedDataSave();
                setIsIncludeTravelFare(true)
            } else {
                props.history.push(`/${localStorage.getItem('i18nextLng')}/login/tour-details`);
            }
        }
    }, 300);

    const fareAmountCancelButton = Utility.debounceButton(async () => {
        const { userSearchDataFromReducer, selected_branch, userCredentials } = props
        let vaildData = true;
        if (vaildData) {
            setCallFromConfirmation("")
            setFareAmountPopupFlag(false)
            if (Object.keys(userCredentials).length > 0) {
                setIsGuestFlag(false)
                await hotelRoomBookedDataSave();
                setIsIncludeTravelFare(false)
            } else {
                setIsGuestFlag(true)
                await hotelRoomBookedDataSave();
                setIsIncludeTravelFare(false)
            }
        }
    }, 300);

    useEffect(() => {
        // console.log("isIncludeTravelFare======",isIncludeTravelFare)
    })

    const getGroupTour = (page = 1, freshData = null) => {
        const searchData = freshData || props.userGroupTourPackageSearchData || {};
        const searchParams = new URLSearchParams();
        if (searchData.starting_from?.value) {
            searchParams.set('from', searchData.starting_from.value);
        }
        if (searchData.going_to?.value) {
            searchParams.set('to', searchData.going_to.value);
        }
        if (searchData.search) {
            searchParams.set('search', searchData.search);
        }
        if (searchData.start_date) {
            const formatted = moment(searchData.start_date).format('YYYY-MM-DD');
            if (formatted && formatted !== 'Invalid date') {
                searchParams.set('start_date', formatted);
            }
        }
        if (searchData.end_date) {
            const formatted = moment(searchData.end_date).format('YYYY-MM-DD');
            if (formatted && formatted !== 'Invalid date') {
                searchParams.set('end_date', formatted);
            }
        }
        const queryString = searchParams.toString();
        history.push(`/${localStorage.getItem('i18nextLng') || 'en'}/tour-list${queryString ? `?${queryString}` : ''}`);
    }

    const { offer_type, offer_amount } = props.tourSearchDataFromReducer || {};
    const currency = props.tourSearchDataFromReducer.hasOwnProperty('branch_details') && props.tourSearchDataFromReducer.branch_details && props.tourSearchDataFromReducer.branch_details.hasOwnProperty('currency') && props.tourSearchDataFromReducer.branch_details.currency || "INR"
    // console.log("------///props.location///-------", props.location)
    useEffect(() => {
        // console.log("slug======",slug)
        if (slug) {
            setOverlay(true);
            // Decode URL params from search query
            const searchData = Utility.decodeUrlParams(history.location.search);
            // Parse URL parameters for tour filters (from, to, search)
            const from = searchData.from || '';
            const to = searchData.to || '';
            const search = searchData.search || '';
            // Create a new search data object for Redux
            let updatedSearchData = props.userGroupTourPackageSearchData || {};
            // Update Redux if search parameters are present in URL
            if (from || to || search) {
                
                let hasChanges = false;
                
                // Handle from parameter
                if (from) {
                    const fromCity = { label: from, value: from };
                    updatedSearchData.starting_from = fromCity;
                    hasChanges = true;
                }
                
                // Handle to parameter
                if (to) {
                    const toCity = { label: to, value: to };
                    updatedSearchData.going_to = toCity;
                    hasChanges = true;
                }
                
                // Handle search parameter
                if (search) {
                    updatedSearchData.search = search;
                    hasChanges = true;
                }
                
                // Update Redux if needed
                if (hasChanges) {
                    props.groupTourPackageSearchData(updatedSearchData);
                }
            }
            
            let filters = {};
            let globalQueryParamshash = {
                tour_type: "group,package"
            };

            // if (updatedSearchData.starting_from?.value?.trim()) {
            //     globalQueryParamshash['from_location'] = updatedSearchData.starting_from.value.trim();
            // }
            // if (updatedSearchData.going_to?.value?.trim()) {
            //     globalQueryParamshash['to_location'] = updatedSearchData.going_to.value.trim();
            // }
            if (updatedSearchData.search?.trim()) {
                globalQueryParamshash['search'] = updatedSearchData.search.trim();
            }
            if (typeof slug === "string") {
               globalQueryParamshash["tour_code"] = slug;
            }
            else if (typeof slug === "number") {
                globalQueryParamshash["branch_id"] = slug
            }
            filters['filters'] = JSON.stringify(globalQueryParamshash);

            getGroupTourApi(filters).then(async (response) => {
                if (response.success) {
                    if (response.data.length > 0) {
                        let reducerData = props.tourSearchDataFromReducer || {};
                        let tempSearchData = { ...reducerData, ...response.data[0] }
                        // console.log("tempSearchData",tempSearchData)
                        props.tourSearchData(tempSearchData)
                        
                        setTimeout(() => {
                            setOverlay(false)
                        }, 700);
                    } else {
                        setGroupTourState([])
                        setOverlay(false)
                        Utility.toastNotifications("No data found", "Warning", "warning")
                        props.history.push(`/${localStorage.getItem('i18nextLng')}/home`)
                    }
                } else {
                    Utility.toastNotifications(response.message, "Error", "danger")
                    setOverlay(false)
                }
            }).catch((error) => {
                console.log("error",error)
                setOverlay(false)
                Utility.toastNotifications("Server Error", "Error", "danger")
            })
        }
    }, [slug, history.location.search]);
    // useEffect(() => {
    //     console.log("props.tourSearchDataFromReducer",props.tourSearchDataFromReducer)
    // }, [props.tourSearchDataFromReducer]);

    const fareAmount = Number(props.tourSearchDataFromReducer?.fare_amount)
    return (
        <div className="booking-details-page hotel-details tour-details-container">
            <GroupPackageSearchPanel
                getGroupTour={getGroupTour}
                setGroupTourState={setGroupTourState}
                callFrom="tour-details"
                is_fixed_date={props.tourSearchDataFromReducer?.is_fixed_date}
                start_date={props.tourSearchDataFromReducer?.start_date}
                end_date={props.tourSearchDataFromReducer?.end_date}
            />
            <div className='container'>
                <BreadcrumbMenu
                    homeMenuDisplay={true}
                    tourListDisplay={true}
                    tourDetailsDisplay={true}
                    homeMenuClick={() => {
                        const currentSearchData = props.userGroupTourPackageSearchData || {};
                        props.groupTourPackageSearchData({
                            ...currentSearchData,
                            start_date: null,
                            end_date: null,
                        });
                        history.push(`/${localStorage.getItem('i18nextLng')}/home`);
                    }}
                    tourListClick={() => {
                        const currentSearchData = props.userGroupTourPackageSearchData || {};
                        props.groupTourPackageSearchData({
                            ...currentSearchData,
                            start_date: null,
                            end_date: null,
                        });
                        history.push(`/${localStorage.getItem('i18nextLng')}/tour-list`);
                    }}
                    tourDetailsClick={() => {}}
                    activeTourDetails={true}
                />
            </div>
            <div className='filterBox filterBoxMBottom'>
                <div className='container'>
                    <div className='leftSectionFilter hotelDetailsTitleBox'>
                        {(() => {
                            const {
                                branch_name,
                                tour_name,
                                duration_days,
                                duration_nights,
                                stopovers,
                                tour_type
                            } = props.tourSearchDataFromReducer || {};

                            const from_location = props.tourSearchDataFromReducer?.DestinationFrom?.destination_name || props.tourSearchDataFromReducer?.from_location;
                            const to_location = props.tourSearchDataFromReducer?.DestinationTo?.destination_name || props.tourSearchDataFromReducer?.to_location;

                            const hasTourName = tour_name != "" && tour_name != null;
                            const hasDays = duration_days != "" && duration_days != null;
                            const hasNights = duration_nights != "" && duration_nights != null;
                            const hasTourType = tour_type != "" && tour_type != null;

                            const hasLocation = from_location || to_location || stopovers;

                            const locationParts = [];
                            if (from_location) locationParts.push(from_location);
                            if (to_location) locationParts.push(to_location);
                            if (stopovers) locationParts.push(stopovers);

                            return (
                                <h2 className='pageTitle'>
                                    {(hasTourName || hasDays || hasNights) && (
                                        <span className='tour_name_duration_na'>
                                            (
                                            {hasTourName && <>{tour_name}</>}
                                            {(hasDays || hasNights) && (
                                                <>
                                                    {" - "}
                                                    {hasNights && `${duration_nights}N/`}
                                                    {hasDays && `${duration_days}D`}
                                                </>
                                            )}
                                            )
                                        </span>
                                    )}

                                    {(hasLocation || hasTourType) && (
                                        <ul className='destinationName hotelDetailsAddress'>
                                            <li>
                                                <OverlayTrigger overlay={<Tooltip>Tour Type</Tooltip>}>
                                                    <span>
                                                        {hasLocation && (
                                                            <>
                                                                <i className="fa fa-map-marker" aria-hidden="true"></i>{" "}
                                                                {locationParts.join(", ")}
                                                            </>
                                                        )}
                                                        {hasLocation && hasTourType && (
                                                            <> &nbsp;|&nbsp; </>
                                                        )}
                                                        {hasTourType && (
                                                            <>
                                                                <i className="fa fa-arrows" aria-hidden="true"></i>{" "}
                                                                {tour_type.charAt(0).toUpperCase() + tour_type.slice(1)}
                                                            </>
                                                        )}
                                                    </span>
                                                </OverlayTrigger>
                                            </li>
                                        </ul>
                                    )}
                                </h2>
                            );
                        })()}
                    </div>
                </div>
            </div>
            <div className='clearfix'></div>
            <div className='container'>
                <div className='col-md-12'>
                    <div className='branch-image-container'>
                        {images.length > 0 && (
                            <div className="col-sm-12 img-caro">
                                <Slider
                                    asNavFor={nav2}
                                    ref={slider1}
                                    arrows={false}
                                    infinite={images.length > 1}
                                    slidesToShow={1}
                                    swipeToSlide={true}
                                    lazyLoad="ondemand"
                                    className="main-slider"
                                >
                                    {images.map((imageValue, index) => {
                                        const imgUrl =
                                            imageValue !== ""
                                                ? imageValue
                                                : require("../../../../Utility/Public/images/no-icon1.png");

                                        return (
                                            <div key={index} className="carousel-main-item">
                                                <LazyImage
                                                    src={imgUrl}
                                                    alt={"room image"}
                                                    loaderImage={require("../../../../Utility/Public/images/no-icon1.png")}
                                                    className="carouselImgpic"
                                                />
                                            </div>
                                        );
                                    })}
                                </Slider>

                                <Slider
                                    asNavFor={nav1}
                                    ref={slider2}
                                    slidesToShow={5}
                                    swipeToSlide={true}
                                    focusOnSelect={true}
                                    arrows={false}
                                    infinite={images.length > 1}
                                    centerMode={false}
                                    className="thumb-slider mt-2"
                                >
                                    {images.map((imageValue, index) => {
                                        const imgUrl =
                                            imageValue !== ""
                                                ? imageValue
                                                : require("../../../../Utility/Public/images/no-icon1.png");

                                        return (
                                            <div key={index} className="carousel-thumb-item">
                                                <LazyImage
                                                    src={imgUrl}
                                                    alt={"room thumbnail"}
                                                    loaderImage={require("../../../../Utility/Public/images/no-icon1.png")}
                                                    className="carouselThumbpic"
                                                />
                                            </div>
                                        );
                                    })}
                                </Slider>
                            </div>
                        )}
                    </div>

                </div>
            </div>
            <div className='clearfix'></div>
            <div className='container'>
                <div className='booking-details-box'>
                    <div className='booking-details-inner'>
                        <div className='row mobRevartTourList'>
                            <div className="col-xl-9 col-md-8 col-sm-12">
                                <div className='detailsRightPanel hotelDetails tourDetailsLeft'>
                                    {roomTypeUi()}
                                </div>
                            </div>
                            <div className="col-xl-3 col-md-4 col-sm-12 bookingProceedRightPanel">
                                <div className='detailsLeftPanel tourDetailsRight grouptourDetailsRight'>
                                    <div className={showFull ? 'inndetailsLeftPanel' : 'inndetailsLeftPanel'}>
                                        <div className='bookingCancelationSection bookingProceedSec yourBookingdetailsBox yourBookingdetailsTourBox'>
                                            <div className='innbookingProceedSec'>
                                                <div className="bookingProceedSecBox pricePackege">
                                                    <h6>Package Price Details</h6>
                                                    <div className='priceBox packagePriceBox'>
                                                        <div className='priceMediaBox'>
                                                            <i className="fa fa-user" aria-hidden="true"></i>
                                                            <div className='priceMediaBoxRight'>
                                                                <h5>{Utility.getCurrencySymbol(currency)} {props.tourSearchDataFromReducer?.price_for_adult} <sub>Price per Adult</sub></h5>
                                                            </div>
                                                        </div>
                                                        <div className='priceMediaBox'>
                                                            <i className="fa fa-user" aria-hidden="true"></i>
                                                            <div className='priceMediaBoxRight'>
                                                                <h5>{Utility.getCurrencySymbol(currency)} {props.tourSearchDataFromReducer?.price_for_children} <sub>Price per Child</sub></h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {(() => {
                                                        const fareAmount = Number(props.tourSearchDataFromReducer?.fare_amount);
                                                        return (
                                                            props.tourSearchDataFromReducer.hasOwnProperty('fare_amount') &&
                                                            fareAmount > 0 && (
                                                                <div className='travel-allowance-box'>
                                                                    <h6>Travel Fare</h6>
                                                                    <div className='priceBox packagePriceBox'>
                                                                        <div className='priceMediaBox'>
                                                                            <div className='priceMediaBoxRight'>
                                                                                <i className="fa fa-car" aria-hidden="true"></i>
                                                                                <h5>{Utility.getCurrencySymbol(currency)} {fareAmount.toFixed(2)} <sub>Price per person</sub></h5>
                                                                            </div>
                                                                            <div className='include-transportation-box'>
                                                                                <label className="include-transportation-check">
                                                                                    Check this if you'd like us to arrange and include transportation.
                                                                                    <input type="checkbox"
                                                                                        checked={isIncludeTravelFare}
                                                                                        onChange={(e) => handleChangeIncludeFareFn(e, "include_transportation")}
                                                                                    />
                                                                                    <span className="checkmark-transportation"></span>
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                        );
                                                    })()}
                                                    {offer_type && offer_amount > 0 && (
                                                        <div className='discountBox'>
                                                            {
                                                                offer_type.toLowerCase() === "flat" ? (
                                                                    <p>{Utility.getCurrencySymbol(currency)} {Number(offer_amount).toFixed(2)} Instant Savings</p>
                                                                ) : offer_type.toLowerCase() === "percentage" ? (
                                                                    <p>Extra {Number(offer_amount).toFixed(2)}% Off</p>
                                                                ) : null
                                                            }
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="bookingCancelationSection bookingProceedSec noSelect">
                                        <div className="innbookingProceedSec">
                                            <div className="bookingProceedSecBox pricePackege bookingProceedtwoBox">
                                                <div className='bookingProceedtwoBoxInn'>
                                                    <h6>Package Details</h6>
                                                    <div className='priceBox text-center'>
                                                        {props.tourSearchDataFromReducer?.itinerary_file_path ? (
                                                            <p>
                                                                <a
                                                                    href={props.tourSearchDataFromReducer.itinerary_file_path}
                                                                    download
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                >
                                                                    Download <i className="fa fa-file-word-o" aria-hidden="true"></i>
                                                                </a>
                                                            </p>
                                                        ) : (
                                                            <p className='no-file-available'>No package details available.</p>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className='bookingProceedtwoBoxInn'>
                                                    <h6>Terms & Conditions</h6>
                                                    <div className='priceBox text-center'>
                                                        {props.tourSearchDataFromReducer?.terms_condition_path ? (
                                                            <p>
                                                                <a
                                                                    href={props.tourSearchDataFromReducer.terms_condition_path}
                                                                    download
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                >
                                                                    Download <i className="fa fa-file-word-o" aria-hidden="true"></i>
                                                                </a>
                                                            </p>
                                                        ) : (
                                                            <p className='no-file-available'>No terms & conditions file available.</p>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <div className='proceedBtnBoxes'>
                                            <button className="proceedBtn">Book Now</button> */}
                                        <div className='proceedBtnBoxes'>
                                            {Object.keys(props.userCredentials).length == 0 &&
                                                <button className='proceedBtn' onClick={() => openGuestCheckOutModalFn()}> Get a Quote</button>}
                                            {/* <button className='proceedBtn mtop5' onClick={() => openProceedPriceDistributionPage()}>{Object.keys(props.userCredentials).length == 0 ? "Book with login" : "Book"}</button> */}
                                        </div>
                                        {/* </div> */}
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {lightboxOpen && lightboxImages.length > 0 && (
                <div className="modal lightbox-modal">
                    <button className="close cursor" onClick={() => setLightboxOpen(false)}>&times;</button>
                    <div className="modal-content lightbox-content">
                        {lightboxImages.map((img, idx) => (
                            <div
                                key={idx}
                                className="mySlides"
                                style={{ display: idx === currentSlide ? 'block' : 'none' }}
                            >
                                <div className="numbertext">{idx + 1} / {lightboxImages.length}</div>
                                <img src={img.src} alt={img.alt} style={{ width: '100%' }} />
                            </div>
                        ))}
                        {lightboxImages.length > 1 && (
                            <>
                                <a className="prev" onClick={() => setCurrentSlide((currentSlide - 1 + lightboxImages.length) % lightboxImages.length)}>&#10094;</a>
                                <a className="next" onClick={() => setCurrentSlide((currentSlide + 1) % lightboxImages.length)}>&#10095;</a>
                            </>
                        )}
                        <div className="row thumbBoxes">
                            {lightboxImages.map((img, idx) => (
                                <div className="column" key={idx}>
                                    <img
                                        src={img.src}
                                        className={`demo cursor ${currentSlide === idx ? 'active' : ''}`}
                                        style={{ width: '100%' }}
                                        onClick={() => setCurrentSlide(idx)}
                                        alt={img.alt}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}
            <ErrorBoundary title="ModalGlobal Error">
                <ModalGlobal
                    show={paymentDetailsModalFlag}
                    onHide={closePaymentDetailsModalFn}
                    title="Customer details"
                    className="modalcustomize mondimension quotationModalDialog quotationModalDialogView bookingModalContentDialog quotationModalDialogForTour enqModalDetail"
                    footer={false}
                    closeButton={true}
                    saveButtonLabel="Payment"
                    saveButtonClassName="btn btn-primary savebtn modbtn"
                    cancelShow={true}
                    cancelButtonLabel={"Next Step"}
                    cancelButtonClassName="modbtn cancelbtn"
                    footerClassName="text-center topspace"
                    minimizeModal={false}
                    maximizeModal={true}
                    body={
                        <>
                            <ErrorBoundary title="BranchAddEditModalContent Error">
                                <TourBooking
                                    tourType={props.tourSearchDataFromReducer?.tour_type}
                                    defaultBranch={defaultBranch}
                                    selectedTour={props.tourSearchDataFromReducer}
                                    quotationCloseModalCallbackFn={closeQuotationCreateModalFn}
                                    gstPercentage={gstPercentage}
                                    sacCodeId={sacCodeId}
                                    isGuestFlag={isGuestFlag}
                                    isLoggedIn={props.isLoggedIn}
                                    closePaymentDetailsModalFn={closePaymentDetailsModalFn}
                                    isIncludeTravelFare={isIncludeTravelFare}
                                    minimumGuestCount={props.tourSearchDataFromReducer.minimum_guest_count}
                                    maximumGuestCount={props.tourSearchDataFromReducer.maximum_guest_count ?? 1}
                                />
                            </ErrorBoundary>
                        </>
                    }
                />
            </ErrorBoundary>
            <ErrorBoundary title="ModalGlobal Error">
                <ModalGlobal
                    show={fareAmountPopupFlag}
                    onHide={closFareAmountPopup}
                    className="modalcustomize confirmationalertmodal"
                    bodyClassName="cancelConfirmationbody"
                    headerclassName="close_btn_icon"
                    title="Include fare amount ?"
                    footer={false}
                    body={
                        <>
                            <ErrorBoundary title="ConfirmationAlert Error">
                                <ConfirmationAlert
                                    BodyFirstContent="Travel fare was not included in your booking. Would you like to include it now?"
                                    BodyThirdContent=""
                                    confirmationButtonContent="Yes"
                                    cancelButtonContent="No"
                                    deleteConfirmButton={fareAmountConfirmButton}
                                    deleteCancleButton={fareAmountCancelButton}
                                    deleteIconVissable={false}
                                />
                            </ErrorBoundary>
                        </>
                    }
                />
            </ErrorBoundary>

        </div >
    )
}


TourDetails.defaultProps = {
    selected_branch: {},
    userSearchDataFromReducer: {},
    tourSearchDataFromReducer: {},
    userGroupTourPackageSearchData: {}
}


const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
        selected_branch: globalState.mainReducerData.selected_branch,
        userSearchDataFromReducer: globalState.mainReducerData.userSearchData,
        priceDistributionRequestData: globalState.mainReducerData.priceDistributionRequestData,
        priceDistributionResponseData: globalState.mainReducerData.priceDistributionResponseData,
        trendingDestinationData: globalState.mainReducerData.trendingDestination,
        tourSearchDataFromReducer: globalState.mainReducerData.tourSearchData,
        userGroupTourPackageSearchData: globalState.mainReducerData.groupTourPackageSearchData
    };
}

export default connect(mapStateToProps, { loaderStateTrue, loaderStateFalse, setUserCredentials, userSearchData, priceDistributionRequestData, priceDistributionResponseData, trendingDestination, tourSearchData, groupTourPackageSearchData })(withRouter(TourDetails));